import { Flex } from 'modules/ui';
import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const FooterButtonsContainer = styled(Flex)`
  gap: 1.563rem;

  > * {
    width: 100%;
  }

  ${mediaQuery('md')} {
    flex-direction: row;
    gap: 2.5rem;
    margin-bottom: 17.375rem;

    > * {
      width: auto;
    }

    button:nth-child(3) {
      margin-left: auto;
    }
  }
`;
